/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Draftemail_Senddate_Label3Inputs */

const en_coinvestments_draftemail_senddate_label3 = /** @type {(inputs: Coinvestments_Draftemail_Senddate_Label3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send date`)
};

/**
* | output |
* | --- |
* | "Send date" |
*
* @param {Coinvestments_Draftemail_Senddate_Label3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_draftemail_senddate_label3 = /** @type {((inputs?: Coinvestments_Draftemail_Senddate_Label3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Draftemail_Senddate_Label3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_draftemail_senddate_label3(inputs)
});
export { coinvestments_draftemail_senddate_label3 as "coInvestments_draftEmail_sendDate_label" }